import { TStripeCoupon } from '@/features/subscription/apiSlice';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import { ApplicationState } from '@/features/publicDatasets/types';

export const formatPrice = (
  price: number,
  addCoupon: boolean,
  currency: Nullable<string>,
  isLineItem?: boolean,
  tax = 0.0,
  coupon?: TStripeCoupon,
) => {
  const finalPrice = isLineItem
    ? price
    : coupon && addCoupon
    ? coupon.percentOff
      ? price / 100 - (price / 100) * (coupon.percentOff / 100)
      : (price - coupon.amountOff) / 100
    : price / 100;

  const priceAfterTax = finalPrice * (1.0 + tax);

  const formattedPrice = isLineItem
    ? priceAfterTax.toFixed(2)
    : Math.ceil(priceAfterTax);

  return currency ? currencySymbol(currency) + formattedPrice : formattedPrice;
};

export const currencySymbol = (currency: string) => {
  switch (currency) {
    case 'gbp':
      return '£';
    case 'usd':
      return '$';
    default:
      return '';
  }
};

export const successMessage = (msg: string, title = '') => {
  NotificationManager.success(msg, title, 10000);
};

export const errorMessage = (
  title: string,
  msg = 'Please try again or contact us if the problem persists.',
) => {
  NotificationManager.error(msg, title, 10000);
};

export const getIsCreditPricing = (state: ApplicationState) =>
  state.datasource.isCreditsPricing;
